// extracted by mini-css-extract-plugin
export var card = "cv-module--card--oZmAT";